<template>
  <div>
    <div
      class="card-backImage"
      :style="{backgroundImage:'url('+imgPrex+item.backImage+')'}"
      v-for="(item,index) in backCardList"
      :key="index"
      @click="showPopup = true;cardIndex = index"
    >
      <img
        class="logo"
        :src="imgPrex+item.logoImage"
      />
      <div class="calorie">{{item.bankName}}</div>
      <div class="savings">储蓄卡</div>
      <div class="savingsId">**** **** **** {{item.acctId | intercept}}</div>
    </div>
    <div
      class="content"
      v-if="!backCardList.length"
    >
      <img
        src="../../assets/img/card.png"
        alt
      />
      暂无银行卡
    </div>
    <van-button
      class="btn"
      block
      to="/register"
    >{{backCardList.length>0?"添加银行卡":"立即添加"}}</van-button>
    <van-popup
      v-model="showPopup"
      position="bottom"
    >
      <div
        class="popup-common van-hairline--bottom"
        @click="unbind"
      >解除绑定</div>
      <div
        class="popup-common"
        @click="showPopup = false"
      >取消</div>
    </van-popup>
  </div>
</template>

<script>
import { getBindingCardList, delCard } from "@/api/join";
export default {
  data() {
    return {
      backCardList: [],
      showPopup: false,
      cardIndex: 0,
    };
  },
  filters: {
    intercept(val) {
      return val.slice(val.length - 4, val.length);
    },
  },
  methods: {
    unbind() {
      this.showPopup = false;
      this.$dialog.alert({
        message: "<b>解绑后，资金将不能提现到该<br/>银行卡中，是否确认解绑！</b>",
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonColor: "#50BE4C",
        cancelButtonColor: "#1993FF",
      })
        .then(() => {
          delCard({
            userTpye: "1",
            cardId: this.backCardList[this.cardIndex].cardId,
          }).then((res) => {
            if (res.appStatus.errorCode == 0) {
              this.$toast("解绑成功");
              this.backCardList.splice(this.cardIndex, 1);
            }
          });
        });
    },
  },
  mounted() {
    getBindingCardList({}).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.backCardList = res.content;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/successfully" || to.path == "/noteCheck") {
      if (this.$store.getters.ambientType == 0) {
        wx.miniProgram.navigateBack({ delta: 9999 });
      } else if (this.$store.getters.ambientType == 1) {
        window.Android.closeHandsel();
      } else if (this.$store.getters.ambientType == 2) {
        window.webkit.messageHandlers.closeHandsel.postMessage("");
      }
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 331px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 17px auto 0;
  font-size: 16px;
  color: #999999;
  border: 1px dashed #999999;
  img {
    width: 36px;
    height: 36px;
  }
}
.btn {
  width: 343px;
  height: 40px;
  margin: 17px auto 0;
  color: #ffffff;
  background-color: #50BE4C;
  border-radius: 50px;
}
.card-backImage {
  width: 331px;
  height: 100px;
  margin: 17px auto 0;
  color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;
  background-size: cover;
  border-radius: 5px;
  .savingsId {
    padding-left: 36px;
    font-size: 24px;
  }
  .calorie {
    padding: 20px 0 0 48px;
    font-size: 12px;
  }
  .savings {
    padding-left: 48px;
    padding-bottom: 4px;
    font-size: 12px;
  }
  .logo {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 20px;
    left: 10px;
  }
}
.popup-common {
  width: 335px;
  height: 60px;
  line-height: 60px;
  margin: 0 auto;
  font-size: 16px;
  color: #333333;
  text-align: center;
}
</style>